export default __webpack_public_path__ + "static/media/kid11.8fbf1b29.jpg";